module.exports = __webpack_public_path__ + "dc81a0e9550cc8263921b0f5a1f0df92.svg";